import { useEffect, useState } from "react";
import QuestionHeaders from "./QuestionHeaders";
import {
  BloodDonationWebContent,
  initialStateBloodDonation } from
"../../utils/constants";
import { getWebContent } from "../../services/epic/bloodDonation";
import DOMPurify from "dompurify";
import { getCurrentLocale } from "../../utils/util";

const WelcomeQuestionStep1 = ({
  setRequestStep,
  requestStep,
  donorDetails,
  cardProfile,
  loading,
  setLoading,
  setSubmittedAnswerData,
  handleCancel,
  translationMap
}) => {
  const [isConsentChecked, setIsConstentChecked] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const currentStep = Math.max(requestStep - 1, 0);
  useEffect(() => {
    let webStructurePKPDF;
    if (getCurrentLocale() === "en" || getCurrentLocale() === 'en_US') {
      webStructurePKPDF = BloodDonationWebContent.webStructurePKPDF;
    } else
    {
      webStructurePKPDF = BloodDonationWebContent.webStructurePKPDF_ar;
    }
    const templateIdWhereToPDF = BloodDonationWebContent.templateIdPDF;
    getWebContent(webStructurePKPDF, templateIdWhereToPDF).then((result) => {
      const element = document.getElementById("pdf");
      const sanitizedContent = DOMPurify.sanitize(result?.data);
      element.innerHTML = sanitizedContent;
    }).catch((error) => {


      //console.error("Error fetching web content:", error);
    });}, []);
  const handleClick = () => {
    if (!isConsentChecked) {
      setErrorMessage(
        translationMap?.mustAcknowledge ||
        "You must acknowledge the Informational Material before proceeding."
      );
    } else {
      setErrorMessage("");
      setRequestStep(3);
      window.parent.scrollTo(0, 0);
    }
  };

  const handleBack = () => {
    if (donorDetails || cardProfile) {
      setRequestStep(-1);
    } else {
      setRequestStep(1);
    }
    setSubmittedAnswerData(initialStateBloodDonation);
  };

  // if(isLoading)
  // {
  //   return(
  //     <Loader/>
  //   )
  // }

  return (
    <>
        <section
        className="w-100 clearfix BloodDonationMainSection"
        id="CoverPlanActive">
        
          <div className="container customContainer">
            <QuestionHeaders
            setRequestStep={setRequestStep}
            currentStep={currentStep}
            translationMap={translationMap} />
          
            <div className="cover_inner_wrapper cover_inner_wrapper2">
              <div className="cover_main_box1">
                <div className="Optimized_Main_Wrap_Box Optimized_Main_Wrap_Box2">
                  <div className="optimized_welcome_box optimized_welcome_box2">
                    <div className="donation_form_title_box">
                      <p className="Gray_Title color_title">
                        {translationMap?.welcome}
                      </p>
                    </div>
                    <div className="description_box">
                      <h6 className="MainTitleOne">
                        {translationMap?.thankYouMsg}
                      </h6>
                      <p className="Gray_Title">
                        {translationMap?.readAboutBloodDonation}
                      </p>
                      
                    </div>
                    <div className="optimized_main_pdf_box" id="pdf"></div>
                    <div className="checkbox_wrapper">
                      <h6 className="Gray_Title">{translationMap?.consent}</h6>
                      <div className="custom_check_box">
                        <input
                        type="checkbox"
                        className="checkboxField"
                        id="checkbox2"
                        onChange={(e) =>
                        setIsConstentChecked(e.target.checked)
                        } />
                      
                        <label htmlFor="checkbox2">
                          {translationMap?.dbdAcknowledge}
                        </label>
                      </div>
                      {errorMessage &&
                    <span id="text" style={{ color: "#FF8F8A" }}>
                          {errorMessage}
                        </span>
                    }
                    </div>
                    <div className="optimized_btn_box">
                      <button onClick={handleClick} className="blue_btn_link">
                        {translationMap?.continue}
                      </button>
                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                      <a
                      role="button"
                      className="bluetrans_btn_link"
                      onClick={handleBack}>
                      
                        {translationMap?.back}
                      </a>
                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                      <a
                      role="button"
                      className="Orangetrans_btn_link"
                      onClick={handleCancel}>
                      
                        {translationMap?.cancel}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="cover_main_box2"></div>
            </div>
          </div>
        </section>
    </>);

};

export default WelcomeQuestionStep1;